/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_HeadingInputs */

const ja_contact_form_heading = /** @type {(inputs: Contact_Form_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const en_contact_form_heading = /** @type {(inputs: Contact_Form_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enquiry`)
};

/**
* | output |
* | --- |
* | "Enquiry" |
*
* @param {Contact_Form_HeadingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const contact_form_heading = /** @type {((inputs?: Contact_Form_HeadingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_HeadingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_contact_form_heading(inputs)
	return en_contact_form_heading(inputs)
});